import {useCallback, useEffect, useState} from "react";
import {get} from "aws-amplify/api";
import {Card, CardBody, Row, Col} from "reactstrap";
import {BackgroundColorContext} from "../contexts/BackgroundColorContext";
import BenchmarksCollection from "../components/Benchmarks/BenchmarksCollection";
import {RingLoader} from "react-spinners";
import {useParams} from "react-router-dom";
import {getWorldName, titleCase} from "../utils/functions";
import PageHeader from "../components/Common/PageHeader";

const BenchmarkActivities = () => {
  const {world} = useParams<{world: string}>();
  const {profile} = useParams<{profile: string}>();
  const {resolution} = useParams<{resolution: string}>();
  const {cpu} = useParams<{cpu: string}>();
  const {gpu} = useParams<{gpu: string}>();

  const [benchmarkActivitiesData, setBenchmarkActivitiesData] = useState([]);
  const [loading, setLoading] = useState(false);

  const worldName: string | undefined = getWorldName(world || "");

  async function getData() {
    try {
      setBenchmarkActivitiesData([]);
      setLoading(true);
      const path: string = `/activities/${world}/${profile}/${resolution}/${decodeURI(cpu || "")}/${decodeURI(gpu || "")}`;
      // console.log(path);
      const {body} = await get({
        apiName: "data",
        path: path
      }).response;
      const data = (await body.json()) as any;
      //console.log(JSON.stringify(data));
      setLoading(false);
      setBenchmarkActivitiesData(data);
    } catch {
      setLoading(false);
      // console.error(`error getting benchmarks activities data: ${err}`);
      return undefined;
    }
  }

  const loadData = useCallback(getData, [world, profile, resolution, cpu, gpu]);

  useEffect(() => {
    async function initialLoad() {
      await loadData();
    }
    initialLoad();
  }, []);

  return (
    <BackgroundColorContext.Consumer>
      {() => (
        <>
          <PageHeader
            title="Benchmark Entries"
            subtitle="Graphics performance for a specific system"
            icon="fa fa-tachometer-alt"
          />
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col md="12">
                      {!loading && (
                        <>
                          <h3>
                            {worldName} / {titleCase(profile || "")} / {resolution}
                          </h3>
                        </>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      {loading && (
                        <div className="iconWrapper">
                          <RingLoader color="#4682b4" size={80} loading={true} />
                        </div>
                      )}
                      {!loading && <BenchmarksCollection items={benchmarkActivitiesData} showLinks={false} />}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </BackgroundColorContext.Consumer>
  );
};

export default BenchmarkActivities;
